export const RESEARCHER_CARD = {
  TITLE: 'Are you a Researcher?',
  DESCRIPTION: 'Please create a researcher account if you wish to post a research opportunity.',
  LINK: {
    URL: '/researcher/create',
    LABEL: 'Sign Up as a Researcher',
  },
  DISMISS: 'Dismiss',
};
